import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IUserSettingsAddPathBodyDataInput, IUserSettingsAddPathResponse } from '../../../../interface/interfaces';

interface IInitialState {
    userSettingsFilePathLoading: boolean;
    userSettingsFilePathData: IUserSettingsAddPathResponse;
    userSettingsFilePathError: string;
}

const userSettingsFilePathDataInitialState: IUserSettingsAddPathResponse = {
    id: 0,
    user_id: '',
    project_id: '',
    device_id: '',
    tool: '',
    file_path: '',
    browser: '',
    os: ''
}

const initialState: IInitialState = {
    userSettingsFilePathLoading: false,
    userSettingsFilePathData: userSettingsFilePathDataInitialState,
    userSettingsFilePathError: '',
};

const userSettingsFilePathSlice = createSlice({
    name: 'userSettingsFilePath',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchUserSettingsFilePathPending: (state: IInitialState, action: PayloadAction<IUserSettingsAddPathBodyDataInput>) => {
            state.userSettingsFilePathLoading = true;
            state.userSettingsFilePathData = userSettingsFilePathDataInitialState;
            state.userSettingsFilePathError = '';
        },

        fetchUserSettingsFilePathFulfilled: (state: IInitialState, action: PayloadAction<IUserSettingsAddPathResponse>) => {
            state.userSettingsFilePathLoading = false;
            state.userSettingsFilePathData = action.payload;
            state.userSettingsFilePathError = '';
        },

        fetchUserSettingsFilePathFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.userSettingsFilePathLoading = false;
            state.userSettingsFilePathData = userSettingsFilePathDataInitialState;
            state.userSettingsFilePathError = action.payload;
        },
    },
});

export default userSettingsFilePathSlice.reducer;
export const { fetchUserSettingsFilePathPending, fetchUserSettingsFilePathFulfilled, fetchUserSettingsFilePathFailure } = userSettingsFilePathSlice.actions;
